import { render } from "./PropertyEvacuation.vue?vue&type=template&id=4a7d93ff&ts=true"
import script from "./PropertyEvacuation.vue?vue&type=script&lang=ts"
export * from "./PropertyEvacuation.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__